import { createContext, useContext } from "react";

import type { Load } from "~/shared/schemas/loads-schema.ts";

/**
 * Runtime values consumed by Loads grid cell renderers. Provided once at the
 * grid root and consumed by stable module-level cell components. This pattern
 * lets us keep the `cells.data` function reference identical across renders
 * even when these runtime values change — which is essential to prevent
 * Kendo Grid from unmounting and remounting every cell on column reorder /
 * preference change (the dominant cost in the perf trace).
 */
export type LoadCellContextValue = {
	isLoading: boolean;
	isInternal: boolean;
	detailsFlyoutEnabled: boolean;
	onDetailsClick?: (load: Load) => void;
	onDocumentClick?: (load: Load) => void;
	onSubscribeToNotifications?: (load: Load) => void;
};

const DEFAULT: LoadCellContextValue = {
	isLoading: false,
	isInternal: false,
	detailsFlyoutEnabled: false,
};

export const LoadCellContext = createContext<LoadCellContextValue>(DEFAULT);

export const useLoadCellContext = (): LoadCellContextValue =>
	useContext(LoadCellContext);
